import React, { useRef, useEffect, useCallback, memo } from "react";
import { clsx } from "clsx";
import { CloseButton } from "components/buttons/CloseButton";
import { useLocation } from "react-router-dom";
import "./WidePopup.scss";
import { useBodyLock } from "@/common/hooks/useBodyLock";

interface IWidePopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  popupClass?: string;
}

export const WidePopup: React.FC<IWidePopupProps> = memo(({
  onClose,
  isOpen,
  title,
  children,
  popupClass,
}) => {
  const popupRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const locationRef = useRef<string>(location.pathname);

  useBodyLock(isOpen);

  const keyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    },
    [onClose, isOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);

    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  useEffect(() => {
    if (locationRef.current !== location.pathname) {
      onClose();
    }
  }, [location]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      ref={popupRef}
      className={clsx("WidePopup", popupClass)}
    >
      <div className="WidePopup-Wrap">
        {title && (
          <div className="WidePopup-Header">
            <CloseButton onClick={onClose} />
            {title && <h4 className="WidePopup-Title">{title}</h4>}
          </div>
        )}
        <div className="WidePopup-Content">
          {children}
        </div>
      </div>
    </div>
  );
});
